module.exports = __webpack_public_path__ + "assets/img/2e8e7a8352111ed823f83457c9fa088f.png";